"use client";

import { useRouter } from "next/navigation";
import { FC, useEffect } from "react";
import { IDetailsPageWrapperProps } from "./types";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";

const DetailsPageWrapper: FC<IDetailsPageWrapperProps> = ({ children, id }) => {
  const router = useRouter();

  useEffect(() => {
    if (!id) {
      router.push("/unoterte");
    }
  }, [id, router]);

  if (!id) {
    return <PageSpinner />;
  }

  return children;
};

export default DetailsPageWrapper;
